
<template>
    <div class="payinfo-wrapper" v-if="payData">
        <div class="pay-info">
            <div class="pay-price">
                <div class="pay-price-title">订单金额</div>
                <div class="pay-price-num">￥{{ payData.totalPrice }}</div>
            </div>
            <div class="pay-info-content">
                <div class="pay-info-title">产品名称</div>
                <div class="pay-info-value">{{ payData.productName }}</div>
            </div>
            <div class="pay-info-content">
                <div class="pay-info-title">购买数量</div>
                <div class="pay-info-value">X {{ totalNum }}份</div>
            </div>
        </div>

        <div class="pay-type-wrapper">
            <div class="pay-type-wx" @click="handlePayWaySelect(1)">
                <div class="pay-type-info-left">
                    <img :src="wxPayIcon" />
                    <div class="pay-type-name">微信支付</div>
                </div>
                <div class="pay-type-info-right">
                    <div
                        class="circle-inner"
                        :class="{ selected: payWay == 1 }"
                    ></div>
                </div>
            </div>
            <div class="pay-type-cmb" @click="handlePayWaySelect(8)">
                <div class="pay-type-info-left">
                    <img :src="cmbPayIcon" />
                    <div class="pay-type-name">一网通银行卡</div>
                </div>
                <div class="pay-type-info-right">
                    <div
                        class="circle-inner"
                        :class="{ selected: payWay == 8 }"
                    ></div>
                </div>
            </div>
        </div>
        <div class="btn-group" @click="submit">
            <img v-if="isCostLoading" :src="loadingSrc" class="loading" /><span
                v-else
                >确认支付</span
            >
        </div>
    </div>
</template>

<script>
export default {
    name: "CheckoutCounter",
    components: {},
    props: {},
    data() {
        return {
            payWay: 0, //1.微信支付；8.一网通银行卡
            payData: null,
            wxPayIcon: "",
            cmbPayIcon: "",
            isCostLoading: false,
            loadingSrc: "",
        };
    },
    computed: {
        payTimes() {
            return this.$route.query.payTimes || 0;
        },
        totalNum() {
            let n = 0;
            if (this.payTimes == 1 && this.payData && this.payData.specsInfo) {
                let specs = JSON.parse(this.payData.specsInfo);
                if (specs instanceof Array) {
                    specs.forEach((e) => {
                        n = n + e.count;
                    });
                }
            }
            if (this.payTimes == 2 && this.payData) {
                n = this.payData.quantity;
            }
            return n;
        },
    },
    watch: {},
    created() {},
    mounted() {
        let vm = this;
        vm.wxPayIcon = require("../../vaporetto-assets/user/png/wx-pay.png");
        vm.cmbPayIcon = require("../../vaporetto-assets/user/png/cmb-pay.png");
        vm.loadingSrc = API.ossUrl + "common/loading.svg";
        let payData = sessionStorage.payData;
        vm.payData = JSON.parse(payData);
    },
    destroyed() {},
    methods: {
        handlePayWaySelect(payWay) {
            this.payWay = payWay;
        },
        submit() {
            if (this.isCostLoading) return;
            let vm = this;
            if (vm.payWay == 0) {
                vm.$toast("请选择支付方式");
                return;
            }
            this.postOrder(UTILS.callPayService);
        },
        postOrder(cb) {
            this.isCostLoading = true;
            this.payData.payWay = this.payWay;
            let url = `${window.API.scene.postOrder}`;
            if (this.payTimes == 1) {
                url = `${window.API.scene.postOrder}`;
            }
            if (this.payTimes == 2) {
                url = `${window.API.order.continuePay}`;
            }
            this.$axios
                .post(`${url}?token=${sessionStorage.token}`, this.payData)
                .then(({ data }) => {
                    this.isCostLoading = false;
                    if (data.code == 200) {
                        localStorage.promoteStr = "";
                        cb && cb(this, data.data);
                    } else {
                        this.$toast(data.msg);
                    }
                })
                .catch((err) => {
                    console.log(err);
                    this.isCostLoading = false;
                });
        },
    },
};
</script>

<style scoped lang="scss">
.payinfo-wrapper {
    min-height: 100%;
    padding: 0.266667rem 0.373333rem 0.88rem 0.373333rem;
    background: #fff;
    .pay-info {
        padding: 0.533333rem 0.426667rem 0.133333rem 0.426667rem;
        box-shadow: 0px 0.053333rem 0.213333rem rgba(174, 174, 174, 0.25);
        border-radius: 0.106667rem;
        .pay-price {
            display: flex;
            justify-content: space-between;
            font-size: 0.533333rem;
            line-height: 0.746667rem;
            margin-bottom: 0.533333rem;
            .pay-price-title {
                font-weight: bold;
                color: #444444;
            }
            .pay-price-num {
                color: #f8b356;
            }
        }
        .pay-info-content {
            display: flex;
            justify-content: space-between;
            font-size: 0.426667rem;
            line-height: 0.586667rem;
            margin-bottom: 0.373333rem;
            .pay-info-title {
                color: #8c8c8c;
            }
            .pay-info-value {
                color: #444444;
            }
        }
    }
    .pay-type-wrapper {
        box-shadow: 0px 0.053333rem 0.213333rem rgba(174, 174, 174, 0.25);
        border-radius: 0.106667rem;
        .pay-type-wx {
            border-bottom: 1px solid #ebebeb;
        }
        .pay-type-wx,
        .pay-type-cmb {
            display: flex;
            justify-content: space-between;
            align-items: center;
            .pay-type-info-left {
                display: flex;
                justify-content: space-between;
                align-items: center;
                height: 1.573333rem;
                img {
                    margin: 0 0.16rem;
                    width: 0.96rem;
                    height: 0.96rem;
                }
                .pay-type-name {
                    font-size: 0.426667rem;
                    line-height: 0.586667rem;
                    color: #444444;
                }
            }
            .pay-type-info-right {
                display: flex;
                justify-content: center;
                align-items: center;
                width: 0.586667rem;
                height: 0.586667rem;
                margin-right: 0.373333rem;
                background: #ffffff;
                border: 0.053333rem solid #d3d3d3;
                border-radius: 50%;
                .circle-inner {
                    width: 0.266667rem;
                    height: 0.266667rem;
                    background: #ffffff;
                    border-radius: 50%;
                }
                .selected {
                    background: #ffbc00;
                }
            }
        }
    }
    .btn-group {
        position: fixed;
        bottom: 0.88rem;
        left: 0.773333rem;
        width: 8.48rem;
        line-height: 1.066667rem;
        background: #ffbc00;
        border-radius: 0.533333rem;
        text-align: center;
        font-size: 0.426667rem;
        color: #ffffff;
    }
}
</style>


